import type { ChecklistCategory } from '../../types';
import { pregnancy1 } from './pregnancy1';
import { pregnancy2 } from './pregnancy2';
import { pregnancy3 } from './pregnancy3';
import { birth } from './birth';
import { postpartumEarly } from './postpartumEarly';
import { postpartumLate } from './postpartumLate';

export const stages = [
  pregnancy1,
  pregnancy2,
  pregnancy3,
  birth,
  postpartumEarly,
  postpartumLate,
];

export const categoryLabels: Record<ChecklistCategory, string> = {
  body: 'からだ',
  mind: 'こころ',
  hospital: '病院・健診',
  admin: '手続き',
  shopping: '買い物',
  life: '暮らし',
  partner: 'パートナー',
};

export const priorityLabels = {
  must: '必須',
  should: '推奨',
  nice: 'あれば便利',
};
